/**
 * @module businessComponents\mdl\levelNavigation
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Model } from "vue-property-decorator";

@Component
export default class LevelNavigation extends Vue {
  @Model("change")
  private value!: any;

  private parent = null;

  private change(item) {
    this.$emit("change", item);
  }

  private test() {}
}
